export default __webpack_public_path__ + "static/media/graphic-18.efde049a.png";